export default "__VITE_ASSET__BN$FKE6q__"